// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
//@constants
const { CARD_SIZE_MEDIUM } = require('constants/index');

class OpenYoungAddDocumentationSuccess extends React.Component {

    render() {
        const { immCard } = this.props;
        const title = formatText('openYoungAddDocumentation-openYoungAddDocumentation_successTitle');
        const goBackButton = {
            label: formatText('openYoungAddDocumentation-openYoungAddDocumentation_backToCard'),
            url: `/myprofile/cards/${immCard.get('cardId')}/movements`,
        };

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8">
                <WizardSuccess
                    mainButton={goBackButton}
                    successMessage={title}
                >
                    <section className="row">
                        <div className="col-xs-5">
                            <CommercialAds
                                immCard={immCard}
                                path="cards"
                                size={CARD_SIZE_MEDIUM}
                                type="cards"
                            />
                        </div>
                        <div className="col-xs-7">
                            <FormattedText
                                value="openYoungAddDocumentation-openYoungAddDocumentation_successMessage"
                            />
                        </div>
                    </section>
                </WizardSuccess>
            </div>
        );
    }
}

OpenYoungAddDocumentationSuccess.propTypes = {
    immCard: PropTypes.object.isRequired,
};

module.exports = OpenYoungAddDocumentationSuccess;